import { PoweredBy } from '@/components/PoweredBy.tsx'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

interface RouterContext {
	queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
	head: () => ({
		meta: [{ title: 'Jobilla' }],
	}),
	component: RootLayout,
	notFoundComponent: NotFoundScreen,
})

function RootLayout() {
	return (
		<div className="antialiased">
			<HeadContent />
			<Outlet />
			<PoweredBy />
		</div>
	)
}

function NotFoundScreen() {
	const { t } = useTranslation('common')

	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-2 px-6 text-center">
			<p className="text-lg font-medium text-grey-800">{t('not_found.title')}</p>
			<p className="max-w-sm text-sm text-grey-500">{t('not_found.body')}</p>
		</div>
	)
}
